import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
// import Fade from '@material-ui/core/Fade';
import { useSpring, animated } from 'react-spring/web.cjs';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  backDrop:{
    background: 'rgba(255,255,255,0.2)',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 400,
    minHeight: 240
  },
}));

const Fade = React.forwardRef(function Fade(props, ref) {
  const { in: open, children, onEnter, onExited, ...other } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited();
      }
    },
  });

  return (
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  );
});

const ModalPopUp = (props)=> {
  const classes = useStyles();
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // className="modal-main"
        className={["modal-main"]}
        style={Object.assign({}, {display:'flex',alignItems:'center', justifyContent:'center'}, props.modalStyle)}
        open={props.isModalOpen}
        onClose={props.onClose}
        closeAfterTransition
        maxWidth={"sm"}
        fullWidth={true}
        // BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          classes: {
            root: classes.backDrop
          }
        }}
        closeAfterTransition
      >
        <Fade in={props.isModalOpen}>
            {props.children}
        </Fade>
      </Modal>
    </div>
  );
}

export default ModalPopUp;